import { onBeforeUnmount, onMounted, watch } from 'vue';
import { shallowEqualObjects } from 'shallow-equal';
export default function useUppy(installPlugin, plugin, uppy, props) {
  onMounted(() => {
    installPlugin();
  });
  onBeforeUnmount(() => {
    uppy.removePlugin(plugin.value);
  });
  watch(() => props.value, (current, old) => {
    if (!shallowEqualObjects(current, old)) {
      plugin.value.setOptions({
        ...current
      });
    }
  });
}